import { callApiToServer } from '../../callApi';

export async function editCountry(
  authtoken,
  countryObject,
  countryId,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        countryId: countryId,
        name: countryObject.name,
        code: countryObject.code,
        isd_code : countryObject.isd_code
    });
  
    let endUrl = "v1/auth/edit-country";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
